import { render, staticRenderFns } from "./excitingSharing.vue?vue&type=template&id=11b32070&scoped=true"
import script from "./excitingSharing.vue?vue&type=script&lang=js"
export * from "./excitingSharing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b32070",
  null
  
)

export default component.exports